import { globalStorage } from 'services/globalStorage';

import { CONCURRENCY_ERROR, CONCURRENCY_ERROR_CODE } from '../../constants';
import { playerStorage } from '../../storages';
import { PlayerEvent } from '../../types';

import { concurrencyError } from './helpers/concurrencyError/concurrencyError';
import { criticalError } from './helpers/criticalError/criticalError';
import { handleKsExpiredError } from './helpers/restorePlayerAfterError/helpers/handleKsExpiredError';

export async function handleError(event: PlayerEvent) {
  const { payload, target } = event;
  const { player, hideUI } = playerStorage.getPlayer();
  const { normalizedCurrentTime } = target;

  if (normalizedCurrentTime > 0) {
    playerStorage.setSavedCurrentTime(normalizedCurrentTime);
  }

  globalStorage.setIsPlayerError(true);

  const isConcurrencyErr =
    payload.data?.data?.messages?.[0].code === CONCURRENCY_ERROR ||
    payload.result?.error?.code === CONCURRENCY_ERROR_CODE;

  // Only call handleKsExpiredError if it hasn't been handled yet
  if (!globalStorage.isKsErrorHandled) {
    const ksExpiredErrorHandled = await handleKsExpiredError(payload);

    if (ksExpiredErrorHandled) {
      return;
    }
  }

  // if not concurrency and Maxi or critical error
  if ((hideUI || payload.severity === player.Error?.Severity?.CRITICAL) && !isConcurrencyErr) {
    criticalError(payload);

    return;
  }

  playerStorage.clearIsPlayBackPausedAndSavedCurrentTime(); // To reset saved parameters if the error is not critical
  globalStorage.clearIsPlayerError();

  if (isConcurrencyErr) {
    concurrencyError(payload);
  }
}
